export async function AntmedicosUpdate(
  antmedResp,
  antmedFecha,
  antmedTipo,
  antmedFamRad,
  antmedFamEsp,
  antmedFumadRad,
  antmedFumadEsp,
  antmedFumadOtr,
  antmedCafeRad,
  antmedCafeEsp,
  antmedSobredRad,
  antmedSobredEsp,
  antmedVihRad,
  antmedAccidRad,
  antmedAccidEsp,
  antmedIntquirRad,
  antmedIntquirEsp,
  antmedIntmedRad,
  antmedIntmedEsp,
  antmedMedicRad,
  antmedMedicEsp,
  antmedAprespRad,
  antmedAprespEsp,
  antmedAprespOtr,
  antmedEnfcardRad,
  antmedEnfcardEsp,
  antmedEnfcardOtr,
  antmedEnfvascRad,
  antmedEnfvascEsp,
  antmedEnfvascOtr,
  antmedEnfdigestRad,
  antmedEnfdigestEsp,
  antmedEnfdigestOtr,
  antmedEnfintestRad,
  antmedEnfintestEsp,
  antmedEnfintestOtr,
  antmedEnfpancRad,
  antmedEnfpancEsp,
  antmedEnfpancOtr,
  antmedEnfrenalRad,
  antmedEnfrenalEsp,
  antmedEnfrenalOtr,
  antmedEnfurinRad,
  antmedEnfurinEsp,
  antmedEnfurinOtr,
  antmedEnfgenitRad,
  antmedEnfgenitEsp,
  antmedEnfgenitOtr,
  antmedAltmenstRad,
  antmedAltmenstEsp,
  antmedAltmenstOtr,
  antmedEmbarzRad,
  antmedEmbarzEsp,
  antmedAbortRad,
  antmedAbortEsp,
  antmedEnfmetabRad,
  antmedEnfmetabEsp,
  antmedEnfmetabOtr,
  antmedEnfpielRad,
  antmedEnfpielEsp,
  antmedEnfpielOtr,
  antmedEnfhematRad,
  antmedEnfhematEsp,
  antmedEnfhematOtr,
  antmedEnfsncsnpRad,
  antmedEnfsncsnpEsp,
  antmedEnfsncsnpOtr,
  antmedAltsuenRad,
  antmedAltsuenEsp,
  antmedAltsuenOtr,
  antmedAltapetRad,
  antmedAltapetEsp,
  antmedAltsexRad,
  antmedAltsexEsp,
  antmedAltsexOtr,
  antmedPatoculRad,
  antmedPatoculEsp,
  antmedPatoculOtr,
  antmedPatauditRad,
  antmedPatauditEsp,
  antmedPatauditOtr,
  antmedPatolfRad,
  antmedPatolfEsp,
  antmedObs,
  tratamientoId,
  pacienteId,
  antmedicosId
) {
  const formData = {
    title: `us-${pacienteId}-tr-${tratamientoId}-antmed-${antmedFecha}`,
    slug: `us-${pacienteId}-tr-${tratamientoId}-antmed-${antmedFecha}`,
    status: "publish",
    tratamiento: tratamientoId,
    paciente: pacienteId,
    meta: {
      antmedResp: antmedResp,
      metaFecha: antmedFecha,
      antmedTipo: antmedTipo,
      metaPaciente: pacienteId,
      antmedFamRad: antmedFamRad,
      antmedFamEsp: antmedFamEsp,
      antmedFumadRad: antmedFumadRad,
      antmedFumadEsp: antmedFumadEsp,
      antmedFumadOtr: antmedFumadOtr,
      antmedCafeRad: antmedCafeRad,
      antmedCafeEsp: antmedCafeEsp,
      antmedSobredRad: antmedSobredRad,
      antmedSobredEsp: antmedSobredEsp,
      antmedVihRad: antmedVihRad,
      antmedAccidRad: antmedAccidRad,
      antmedAccidEsp: antmedAccidEsp,
      antmedIntquirRad: antmedIntquirRad,
      antmedIntquirEsp: antmedIntquirEsp,
      antmedIntmedRad: antmedIntmedRad,
      antmedIntmedEsp: antmedIntmedEsp,
      antmedMedicRad: antmedMedicRad,
      antmedMedicEsp: antmedMedicEsp,
      antmedAprespRad: antmedAprespRad,
      antmedAprespEsp: antmedAprespEsp,
      antmedAprespOtr: antmedAprespOtr,
      antmedEnfcardRad: antmedEnfcardRad,
      antmedEnfcardEsp: antmedEnfcardEsp,
      antmedEnfcardOtr: antmedEnfcardOtr,
      antmedEnfvascRad: antmedEnfvascRad,
      antmedEnfvascEsp: antmedEnfvascEsp,
      antmedEnfvascOtr: antmedEnfvascOtr,
      antmedEnfdigestRad: antmedEnfdigestRad,
      antmedEnfdigestEsp: antmedEnfdigestEsp,
      antmedEnfdigestOtr: antmedEnfdigestOtr,
      antmedEnfintestRad: antmedEnfintestRad,
      antmedEnfintestEsp: antmedEnfintestEsp,
      antmedEnfintestOtr: antmedEnfintestOtr,
      antmedEnfpancRad: antmedEnfpancRad,
      antmedEnfpancEsp: antmedEnfpancEsp,
      antmedEnfpancOtr: antmedEnfpancOtr,
      antmedEnfrenalRad: antmedEnfrenalRad,
      antmedEnfrenalEsp: antmedEnfrenalEsp,
      antmedEnfrenalOtr: antmedEnfrenalOtr,
      antmedEnfurinRad: antmedEnfurinRad,
      antmedEnfurinEsp: antmedEnfurinEsp,
      antmedEnfurinOtr: antmedEnfurinOtr,
      antmedEnfgenitRad: antmedEnfgenitRad,
      antmedEnfgenitEsp: antmedEnfgenitEsp,
      antmedEnfgenitOtr: antmedEnfgenitOtr,
      antmedAltmenstRad: antmedAltmenstRad,
      antmedAltmenstEsp: antmedAltmenstEsp,
      antmedAltmenstOtr: antmedAltmenstOtr,
      antmedEmbarzRad: antmedEmbarzRad,
      antmedEmbarzEsp: antmedEmbarzEsp,
      antmedAbortRad: antmedAbortRad,
      antmedAbortEsp: antmedAbortEsp,
      antmedEnfmetabRad: antmedEnfmetabRad,
      antmedEnfmetabEsp: antmedEnfmetabEsp,
      antmedEnfmetabOtr: antmedEnfmetabOtr,
      antmedEnfpielRad: antmedEnfpielRad,
      antmedEnfpielEsp: antmedEnfpielEsp,
      antmedEnfpielOtr: antmedEnfpielOtr,
      antmedEnfhematRad: antmedEnfhematRad,
      antmedEnfhematEsp: antmedEnfhematEsp,
      antmedEnfhematOtr: antmedEnfhematOtr,
      antmedEnfsncsnpRad: antmedEnfsncsnpRad,
      antmedEnfsncsnpEsp: antmedEnfsncsnpEsp,
      antmedEnfsncsnpOtr: antmedEnfsncsnpOtr,
      antmedAltsuenRad: antmedAltsuenRad,
      antmedAltsuenEsp: antmedAltsuenEsp,
      antmedAltsuenOtr: antmedAltsuenOtr,
      antmedAltapetRad: antmedAltapetRad,
      antmedAltapetEsp: antmedAltapetEsp,
      antmedAltsexRad: antmedAltsexRad,
      antmedAltsexEsp: antmedAltsexEsp,
      antmedAltsexOtr: antmedAltsexOtr,
      antmedPatoculRad: antmedPatoculRad,
      antmedPatoculEsp: antmedPatoculEsp,
      antmedPatoculOtr: antmedPatoculOtr,
      antmedPatauditRad: antmedPatauditRad,
      antmedPatauditEsp: antmedPatauditEsp,
      antmedPatauditOtr: antmedPatauditOtr,
      antmedPatolfRad: antmedPatolfRad,
      antmedPatolfEsp: antmedPatolfEsp,
      antmedObs: antmedObs,
    },
  };

  const authToken = sessionStorage.getItem("token");

  try {
    const response = await fetch(
      `https://app.tavad.com/hce/wp-json/wp/v2/antmedicos/${antmedicosId}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      }
    );
    const values = await response.json();
    console.log(values);
    return values;
  } catch (error) {
    console.error(error);
  }
}
